module.exports = __webpack_public_path__ + "img/info-8.f9f12d9d.svg";